// import React from 'react';
// import '../Styles/Asking.css';
// import SaviLogo from '../Images/Savihorizontallogo.png';
// import Navbar from '../Compoanents/Navbar';
// import { Link } from 'react-router-dom';

// const Asking = () => {
//   return (
//     <div className="savi-container">
//       <Navbar />
//       <main className="savi-main">
//         <section className="hero-section">
//           <div className="hero-content-left">
//             <div className="logo-block">
//               <div className="logo-container">
//                 <img src={SaviLogo} alt="SAVI AI Logo" className="savi-logo" />
//               </div>
//             </div>
//             <div className='total-subheading'>
//               <div>
//                 <h2 className="sub-heading">
//                   Supercharge your business<br />
//                   and productivity
//                 </h2>
//                 <p className="description">
//                   Chat to start writing, planning, learning<br />
//                   and more with SAVI AI
//                 </p>
//               </div>
//               <div className="cta-buttons">
//                 <Link to="/login">
//                   <button className="sign-in-btn-alt">Sign in</button>
//                 </Link>
//                 <Link to='/register'>
//                 <button className="sign-up-btn">Sign up</button>
//                 </Link>
//               </div>
//             </div>
//           </div>

//           <div className='hero-card'>
//             <div className='text-hero'>
//               <h2>Supercharge your business and productivity</h2>
//               <p>Chat to start writing, planning, learning and more with SAVI AI</p>
//             </div>
//           </div>
//         </section>

//         <section className="for-you-section">
//           <h3>For you</h3>
//           <div className="feature-cards">
//             <div className="feature-card">
//               <div className="feature-image-placeholder"></div>
//               <div className="feature-content">
//                 <h4>Supercharge</h4>
//                 <p className="feature-title">your business and take</p>
//                 <p className="feature-detail">I will help you to make productivity to a different level</p>
//               </div>
//             </div>
//             <div className="feature-card">
//               <div className="feature-image-placeholder"></div>
//               <div className="feature-content">
//                 <h4>Supercharge</h4>
//                 <p className="feature-title">your business and take</p>
//                 <p className="feature-detail">I will help you to make productivity to a different level</p>
//               </div>
//             </div>
//           </div>
//         </section>
//       </main>
//     </div>
//   );
// };

// export default Asking;



import React from 'react';
import '../Styles/Asking.css';
import logo from '../Images/SAVI AI full.png';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const Asking = () => {
  const navigate = useNavigate();

  const handlesignin = () => {
    navigate('/login');
  }

  const handlesignup = () => {
    navigate('/register')
  }
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'light';
    document.documentElement.setAttribute('data-theme', savedTheme);
  }, []);
  useEffect(() => {
    // Set theme on mount
    const setTheme = () => {
      const savedTheme = localStorage.getItem('theme') || 'light';
      document.documentElement.setAttribute('data-theme', savedTheme);
    };
    setTheme();

    // Listen for theme changes in other tabs/components
    const handleStorage = (e) => {
      if (e.key === 'theme') {
        setTheme();
      }
    };
    window.addEventListener('storage', handleStorage);

    return () => window.removeEventListener('storage', handleStorage);
  }, []);
  return (
    <div className="asking-main-container">
      <header className="asking-header">
        <div className="asking-logo">
          <img src={logo} alt="Logo" className="asking-logo-image" />
        </div>
      </header>

      <div className="asking-content-container">
        <div className="asking-welcome-box">
          <h1 className="asking-title">
            Welcome to <span className="asking-title-highlight">Savi</span>
          </h1>
          <p className="asking-description">
            Join thousands of users and access all our features.
          </p>

          <div className="asking-buttons-container">
            <button className="asking-signin-button" onClick={handlesignin}>
              Sign In
            </button>
            <button className="asking-signup-button" onClick={handlesignup}>
              Sign Up
            </button>
          </div>

          <div className="asking-info-text">
            New here? Create an account to get started.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Asking;